//import DateFormat from "@/libs/DateFormat"

export default class Menu {
  constructor(data = {}) {
    return {
      id: data.id || "",
      name: data.name || "",
    };
  }
}
